import { BudgetYearLimitDetailContainer } from "../../../containers/SupportSystem/Admin/BudgetYearLimitDetailContainer";
export function BudgetYearLimitDetailPage () {
    return(
       <BudgetYearLimitDetailContainer/>
    )
}